// TODO: Remove once BE is fixed.
//       Otherwise we need to hardcode these every year and for every single
//       Package for all customers that are active.

const lakefrontMusicFest = ticketTypeId => {
  // Lakefront Music Fest
  if (
    ticketTypeId === 37381 ||
    ticketTypeId === 38449 ||
    ticketTypeId === 38450
  ) {
    // EventDateID
    return 27409; // Saturday 2026
  } else if (
    ticketTypeId === 37366 ||
    ticketTypeId === 38448 ||
    ticketTypeId === 38451
  ) {
    // EventDateID
    return 27408; // Friday 2026
  }
  // send warning to Sentry?
  return undefined;
};

const prideBlockParty = ticketTypeId => {
  // Pride Block Party
  if (ticketTypeId === 38258) {
    // GA Weekend Pass Fri
    return 27867; // Friday 2026
  } else if (ticketTypeId === 38263) {
    // GA Weekend Pass - Sat
    return 27868; // Saturday 2026
  } else if (ticketTypeId === 38268) {
    // GA Weekend Pass - Sun
    return 27869; // Sunday 2026
  }
};

const stCroixEventCenter = ticketTypeId => {
  // MURDER MYSTERY DINNER
  if (ticketTypeId === 37588) {
    // 2 Night Package - FRIDAY, "I Should Have Known"
    return 27489;
  } else if (ticketTypeId === 37587) {
    // 2 Night Package - SATURDAY, "It's Your Last Day"
    return 27490;
  }
};

export const getPackage2026DateID = ticketTypeId => {
  const dateID = stCroixEventCenter(ticketTypeId);
  if (typeof dateID === "number") return dateID;
  const prideDateID = prideBlockParty(ticketTypeId);
  if (typeof prideDateID === "number") return prideDateID;
  return lakefrontMusicFest(ticketTypeId);
};
